module.exports = __webpack_public_path__ + "media/images/flags/64/Bulgaria-b5b1b6bbb74d97bcda087c949ff60a2d.png";